(function () {
  function initMembersModalSliders() {
    document.querySelectorAll('[data-members-slider]').forEach(function (slider) {
      if (slider.dataset.membersSliderInit === '1') {
        return;
      }
      slider.dataset.membersSliderInit = '1';
      var viewport = slider.querySelector('.kotei-members-modal__viewport');
      var track = slider.querySelector('.kotei-members-modal__track');
      var slides = slider.querySelectorAll('.kotei-members-modal__slide');
      var prevBtn = slider.querySelector('.kotei-members-modal__slider-btn--prev');
      var nextBtn = slider.querySelector('.kotei-members-modal__slider-btn--next');
      if (!viewport || !track || slides.length === 0) {
        return;
      }
      var index = 0;
      function slideCount() {
        return slides.length;
      }
      function update() {
        var w = viewport.offsetWidth;
        track.style.transform = 'translateX(' + -index * w + 'px)';
        var hide = slideCount() <= 1;
        if (prevBtn) {
          prevBtn.hidden = hide;
        }
        if (nextBtn) {
          nextBtn.hidden = hide;
        }
      }
      function go(delta) {
        var n = slideCount();
        if (n === 0) {
          return;
        }
        index = (index + delta + n) % n;
        update();
      }
      slider._membersSliderReset = function () {
        index = 0;
        track.style.transform = '';
        update();
      };
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          go(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          go(1);
        });
      }
      window.addEventListener(
        'resize',
        function () {
          update();
        },
        { passive: true },
      );
      update();
    });
  }

  var buttons = document.querySelectorAll('[data-members-modal-open]');
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-members-modal-open');
      var dlg = document.getElementById(id);
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        initMembersModalSliders();
        var s = dlg.querySelector('[data-members-slider]');
        if (s && typeof s._membersSliderReset === 'function') {
          s._membersSliderReset();
        }
      }
    });
  });
  initMembersModalSliders();
  document.querySelectorAll('.kotei-members-modal').forEach(function (dlg) {
    dlg.querySelectorAll('.kotei-members-modal__close').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dlg.close();
      });
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) {
        dlg.close();
      }
    });
    dlg.addEventListener('close', function () {
      var s = dlg.querySelector('[data-members-slider]');
      if (s && typeof s._membersSliderReset === 'function') {
        s._membersSliderReset();
      }
    });
  });
})();
